var _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUrgentDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 37C2 24.0786 2 17.618 5.13166 12.9944C6.42888 11.0793 8.07926 9.42888 9.99445 8.13166C14.618 5 21.0786 5 34 5V5C46.9214 5 53.382 5 58.0055 8.13166C59.9207 9.42888 61.5711 11.0793 62.8683 12.9944C66 17.618 66 24.0786 66 37V37C66 49.9214 66 56.382 62.8683 61.0055C61.5711 62.9207 59.9207 64.5711 58.0055 65.8683C53.382 69 46.9214 69 34 69V69C21.0786 69 14.618 69 9.99445 65.8683C8.07926 64.5711 6.42888 62.9207 5.13166 61.0055C2 56.382 2 49.9214 2 37V37Z",
    fill: "url(#paint0_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_iif)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.6062 37.3595C56.6062 49.6463 46.6459 59.6067 34.3592 59.6067C22.0726 59.6067 12.1123 49.6463 12.1123 37.3595C12.1123 25.0727 22.0726 15.1123 34.3592 15.1123C46.6459 15.1123 56.6062 25.0727 56.6062 37.3595Z",
    fill: "url(#paint1_linear)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3169 9.00195C14.3169 8.17353 14.9885 7.50195 15.8169 7.50195H52.8169C53.6453 7.50195 54.3169 8.17353 54.3169 9.00195V9.00195C54.3169 9.83038 53.6453 10.502 52.8169 10.502H15.8169C14.9885 10.502 14.3169 9.83038 14.3169 9.00195V9.00195Z",
    fill: "#FAFAFA"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.6919 56.875C62.2777 56.875 61.9419 56.5392 61.9419 56.125V17.625C61.9419 17.2108 62.2777 16.875 62.6919 16.875V16.875C63.1061 16.875 63.4419 17.2108 63.4419 17.625V56.125C63.4419 56.5392 63.1061 56.875 62.6919 56.875V56.875Z",
    fill: "#F8F8F8"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.56689 56.875C5.35979 56.875 5.19189 56.7071 5.19189 56.5L5.19189 17.25C5.19189 17.0429 5.35979 16.875 5.56689 16.875V16.875C5.774 16.875 5.94189 17.0429 5.94189 17.25L5.94189 56.5C5.94189 56.7071 5.774 56.875 5.56689 56.875V56.875Z",
    fill: "#F8F8F8"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.4459 23.2021C6.21606 23.2021 6.03274 23.0434 6.04556 22.8512C6.12738 21.624 6.50597 17.4884 7.97626 15.4359C9.58739 13.1867 13.1893 11.3544 13.7084 11.098C13.751 11.077 13.7972 11.0673 13.8467 11.0673V11.0673C14.1041 11.0673 14.2323 11.3311 14.0475 11.4811C12.9713 12.3538 10.4745 14.4256 9.13525 15.9212C7.64728 17.583 7.00828 21.7339 6.85502 22.8957C6.83193 23.0707 6.65618 23.2021 6.4459 23.2021V23.2021Z",
    fill: "#FAFAFA"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.6667 23.708C61.8673 23.708 62.0272 23.5427 62.016 23.3424C61.9447 22.0641 61.6143 17.7562 60.3315 15.6181C58.9257 13.2753 55.7831 11.3666 55.3301 11.0995C55.2929 11.0776 55.2526 11.0676 55.2094 11.0676V11.0676C54.9849 11.0676 54.8729 11.3424 55.0343 11.4985C55.9732 12.4076 58.1517 14.5657 59.3202 16.1237C60.6185 17.8548 61.1761 22.1786 61.3098 23.3888C61.3299 23.5711 61.4833 23.708 61.6667 23.708V23.708Z",
    fill: "#FAFAFA"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.16525 16.5202C8.11128 16.4996 8.08436 16.4394 8.10612 16.3859C8.2138 16.121 8.53818 15.3617 8.96923 14.7079C9.43402 14.0029 10.1114 13.5718 10.2754 13.474C10.2986 13.4601 10.3267 13.4582 10.3519 13.4678V13.4678C10.4194 13.4936 10.4329 13.584 10.3761 13.6287C10.1107 13.8377 9.5071 14.334 9.16466 14.7825C8.79389 15.2681 8.41915 16.1659 8.30102 16.4608C8.27955 16.5145 8.21921 16.5408 8.16525 16.5202V16.5202Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.8919 16.5202C59.9458 16.4996 59.9728 16.4394 59.951 16.3859C59.8433 16.121 59.5189 15.3617 59.0879 14.7079C58.6231 14.0029 57.9457 13.5718 57.7818 13.474C57.7586 13.4601 57.7305 13.4582 57.7052 13.4678V13.4678C57.6377 13.4936 57.6242 13.584 57.681 13.6287C57.9464 13.8377 58.55 14.334 58.8925 14.7825C59.2632 15.2681 59.638 16.1659 59.7561 16.4608C59.7776 16.5145 59.8379 16.5408 59.8919 16.5202V16.5202Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7429 27.5947L26.6655 29.4504C26.7533 29.5352 26.7533 29.6745 26.6655 29.7593L25.5442 30.8416C25.4536 30.9263 25.312 30.9263 25.2243 30.8416L23.3016 28.9858C23.2595 28.9447 23.2358 28.8892 23.2358 28.8314C23.2358 28.7736 23.2595 28.7181 23.3016 28.677L24.4229 27.5947C24.4655 27.554 24.523 27.5312 24.5829 27.5312C24.6428 27.5312 24.7003 27.554 24.7429 27.5947ZM43.0629 27.5947C43.1055 27.554 43.163 27.5312 43.2229 27.5312C43.2828 27.5312 43.3403 27.554 43.3829 27.5947L44.5042 28.677C44.592 28.7617 44.592 28.8984 44.5042 28.9858L42.5816 30.8416C42.4938 30.9263 42.3494 30.9263 42.2616 30.8416L41.1403 29.7593C41.0982 29.7182 41.0745 29.6627 41.0745 29.6048C41.0745 29.547 41.0982 29.4915 41.1403 29.4504L43.0629 27.5947ZM33.9082 26.2637V25.2251H33.892V26.2637H33.9082ZM25.7736 44.9852C25.2724 44.9852 24.8675 44.5944 24.8675 44.1106V37.7426C24.8675 32.9269 28.9109 29.0241 33.9001 29.0241C38.8893 29.0241 42.9327 32.9269 42.9327 37.7426V44.1106C42.9327 44.5944 42.5278 44.9852 42.0266 44.9852H25.7736ZM33.9001 30.9919C30.0379 30.9919 26.9062 34.0147 26.9062 37.7426V43.0174H29.0298V38.3438C29.0298 38.1935 29.1573 38.0705 29.313 38.0705H30.5589C30.7146 38.0705 30.842 38.1935 30.842 38.3438V43.0174H40.894V37.7426C40.894 34.0147 37.7623 30.9919 33.9001 30.9919ZM24.8392 46.7344H42.961C43.4622 46.7344 43.8671 47.1252 43.8671 47.609V48.2649C43.8671 48.3851 43.7652 48.4835 43.6406 48.4835H24.1596C24.035 48.4835 23.9331 48.3851 23.9331 48.2649V47.609C23.9331 47.1252 24.338 46.7344 24.8392 46.7344ZM34.6929 27.2749H33.1073C32.9827 27.2749 32.8807 27.1765 32.8807 27.0563V24.4325C32.8807 24.3123 32.9827 24.2139 33.1073 24.2139H34.6929C34.8175 24.2139 34.9194 24.3123 34.9194 24.4325V27.0563C34.9194 27.1765 34.8175 27.2749 34.6929 27.2749Z",
    fill: "url(#paint2_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_iif",
    x: 10.6123,
    y: 14.217,
    width: 46.9939,
    height: 46.2849,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 0.895261
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.79052
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.5,
    dy: -0.895261
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.866667 0 0 0 0 0.866667 0 0 0 0 0.866667 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow",
    result: "effect2_innerShadow"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect3_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f",
    x: 7.76551,
    y: 0.950565,
    width: 53.1028,
    height: 16.1028,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.27569,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f",
    x: 57.3683,
    y: 12.3014,
    width: 10.6472,
    height: 49.1472,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.28681,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f",
    x: 0.618284,
    y: 12.3014,
    width: 9.89722,
    height: 49.1472,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.28681,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f",
    x: 3.24492,
    y: 8.26738,
    width: 13.6899,
    height: 17.7348,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.4,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f",
    x: 52.158,
    y: 8.26738,
    width: 12.6586,
    height: 18.2405,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.4,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f",
    x: 7.06885,
    y: 12.0908,
    width: 4.37025,
    height: 5.80306,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f",
    x: 56.6182,
    y: 12.0908,
    width: 4.37025,
    height: 5.80306,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d",
    x: 23.2358,
    y: 24.2139,
    width: 23.3342,
    height: 26.2697,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.7 0 0 0 0 0.7 0 0 0 0 0.7 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 34.3596,
    y1: 5,
    x2: 34.3596,
    y2: 70.2247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBBBBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 32.337,
    y1: 14.1011,
    x2: 35.8764,
    y2: 58.0898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5C5C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 33.9029,
    y1: 24.2139,
    x2: 34.3594,
    y2: 48.4835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAEAEA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUrgentDisabled);
export default __webpack_public_path__ + "static/media/icon_urgent_disabled.015420914b6973e9bced36d2f21c7373.svg";
export { ForwardRef as ReactComponent };